//utils
import './utils/plugins';
import './utils/translations';
import './utils/global-components';
import moment from 'moment';
import VueGtm from '@gtm-support/vue2-gtm';
import './utils/laravel-echo';
import tokenUtils from './utils/tokens';
//
import Vue from 'vue';
import App from './App.vue';
import router from '@/router/index';
import store from '@/store';
import * as Sentry from "@sentry/vue";
import PortalVue from "portal-vue";
import Vue2ClickOutside from 'vue2-click-outside'

Vue.prototype.moment = moment;

//vue configs
Vue.config.productionTip = false;

if (tokenUtils.hasActualToken()) {
    store.state.auth.isAuthenticated = true;
}

Vue.prototype.$bus = new Vue;

const app = new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('render-event'))
    }
});

window.$VUE_APP = app;

if (process.env.VUE_APP_ROOT_AUTH.indexOf('genius.space') != -1) {
    console.log('init sentry');
    
    Sentry.init({
        Vue,
        dsn: "https://dd294c8e689e487ea42bc4d5dcc9ff86@o4505595298250752.ingest.sentry.io/4505595944697856",
        integrations: [
            new Sentry.BrowserTracing({
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: ["localhost", "https:yourserver.io/api/"],
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
            new Sentry.Replay(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

Vue.initI18nManager().then(() => {
    app.$mount('#app');
});

if (process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID) {
    Vue.use(VueGtm, {
        id: `GTM-${process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID}`,
        enabled: true,
        vueRouter: router,
    });
}

Vue.use(PortalVue);

Vue.use(Vue2ClickOutside)
